import React from 'react';
import MarketOverview from './static/MarketOverview';
import TrendsSummary from './TrendsSummary';
import StaticSection from './static/StaticSection';
import FullAccessBanner from './FullAccessBanner';

const AiDashboardStaticView = () => (
  <div className="ai-dashboard-tab-content">
    <div id="market-overview">
      <MarketOverview />
    </div>

    <div className="separator-h" />
    <FullAccessBanner />

    <div id="behavioral-trends" className="d-flex flex-column align-items-center gap-24">
      <TrendsSummary allowQV={false} />
      <StaticSection variant="behavioral-trends" height={475} />
    </div>

    <div id="market-behavior">
      <StaticSection variant="market-behavior" height={1712} />
    </div>

    <div id="screen-time-by-sector">
      <StaticSection variant="screen-time-by-sector" height={827} />
    </div>

    <div id="app-trends">
      <StaticSection variant="app-trends" height={981} />
    </div>

    <div id="ai-app-impact">
      <StaticSection variant="ai-app-impact" height={597} />
    </div>
  </div>
);

export default AiDashboardStaticView;
